import { useEffect } from "react";
import { useFeedsModulesStore } from "@/common/store/feedsModulesStore";
import { apiFeeds } from "@/common/services";
import { useLocation } from "react-router-dom";

const LIFETIME = 600; // 10 minutes
const MS_IN_SEC = 1000;

export const useFeedModules = () => {
  const { pathname } = useLocation();
  const feedModules = useFeedsModulesStore((state) => state.modules);
  const expireAt = useFeedsModulesStore((state) => state.expireAt);
  const setFeedsModules = useFeedsModulesStore((state) => state.setFeedsModules);
  const setExpireAt = useFeedsModulesStore((state) => state.setExpireAt);
  const setLoading = useFeedsModulesStore((state) => state.setLoading);

  useEffect(() => {
    if (pathname.indexOf("/ifr/") === 0) {
      return;
    }

    (async () => {
      const now = Math.round((new Date()).getTime() / MS_IN_SEC);

      if (feedModules === undefined || expireAt === undefined || expireAt <= now) {
        try {
          setLoading(true);

          const { modules } = await apiFeeds.getFeedModules();

          setFeedsModules(modules);
          setExpireAt(Math.round((new Date()).getTime() / MS_IN_SEC) + LIFETIME);
        } catch (e) {
          console.warn("Error loading feed modules", e);
        } finally {
          setLoading(false);
        }
      }
    })();
  }, [pathname, expireAt, feedModules]);
};
